var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col justify-center items-center py-5 px-1 border-t border-r border-b border-gray-500"},[_c('div',{staticClass:"text-base text-inherit print:text-[12px] print:font-semibold"},[_vm._v(_vm._s(_vm.day))]),_vm._v(" "),_c('div',{staticClass:"text-sm text-inherit"},[_vm._v(_vm._s(_vm.date))])])
}
var staticRenderFns = []

export { render, staticRenderFns }